import { findFieldByElement } from './lib/findFieldByElement';
import { findFieldByType } from './lib/findFieldByType';

export const submissionKey = (submissionId, sessionId) => ['submission', submissionId, sessionId];

export const paymentKey = (paymentId, sessionId) => ['payment', paymentId, sessionId];

export const eventPaymentKey = (paymentId, sessionId) => ['event_payment', paymentId, sessionId];

export const subscriptionKey = (subscriptionId, sessionId) => [
  'subscription',
  subscriptionId,
  sessionId,
];

export const checkoutKey = (sellerId, checkoutId, previewKey) =>
  ['checkout', sellerId, checkoutId, previewKey].filter(Boolean);

export const countryKey = ['country'];

export const templateKey = pageId => ['template', pageId];

export const checkoutEventKey = (pageId, checkoutId) => ['checkout_event', pageId, checkoutId];

const getCountryFieldValue = fields => {
  const countryField = findFieldByElement(fields, 'country');
  const shippingCountryField = findFieldByType(fields, 'shipping-address-country');
  const billingCountryField = findFieldByType(fields, 'address-country');

  const country = countryField?.value || shippingCountryField?.value || billingCountryField?.value;

  return country;
};

export const taxCalculationQueryKey = ({
  sellerId,
  pageId,
  fields,
  variants,
  tickets,
  couponId,
  customerId,
  payWhatYouWantPrice,
  dynamicPrice,
  selectedPaymentMethod,
}) => {
  const taxIdField = findFieldByElement(fields, 'tax-id');
  const taxIdType = taxIdField?.meta?.type;
  const taxId = taxIdField?.value;

  const country = getCountryFieldValue(fields);

  const postalCodeField = Object.values(fields).find(
    field => field.type === 'address-postal_code' || field.type === 'shipping-address-postal_code',
  );

  const stateField = Object.values(fields).find(
    field => field.type === 'address-state' || field.type === 'shipping-address-state',
  );

  const quantityField = Object.values(fields).find(field => field.element === 'quantity');

  const variantsKey = Object.entries(variants)
    .map(([variantId, value]) => {
      if (typeof value === 'string') {
        return `${variantId}:${value}`;
      }

      return `${variantId}:${value?.map(opt => `${opt.optionId}=${opt.quantity || 0}`).join('|') || ''
        }`;
    })
    .join(',');

  const ticketsKey = Object.entries(tickets)
    .map(([key, value]) => `${key}:${value}`)
    .join(',');

  return [
    'taxCalculation',
    sellerId,
    pageId,
    variantsKey,
    ticketsKey,
    country,
    postalCodeField?.value,
    stateField?.value,
    quantityField?.value,
    taxIdType,
    taxId,
    couponId,
    customerId,
    payWhatYouWantPrice,
    selectedPaymentMethod,
    dynamicPrice,
  ];
};

export const prorationCalculationQueryKey = ({
  sellerId,
  pageId,
  variants,
  quantity,
  selectedPaymentMethod,
  couponId,
  billingCycleAnchorConfigEnabled,
  dayOfMonth,
  month,
}) => [
    'proration',
    sellerId,
    pageId,
    variants,
    quantity,
    selectedPaymentMethod,
    couponId,
    billingCycleAnchorConfigEnabled,
    dayOfMonth,
    month,
  ];
